<template>
  <div class="my-points">
    <div class="section-title">我的积分</div>

    <!-- 积分信息 -->
    <div class="points-info">
      <div class="info-item">
        <div class="label">当前积分</div>
        <div class="value">0</div>
      </div>
      <div class="info-item">
        <div class="label">累计积分</div>
        <div class="value">0</div>
      </div>
      <div class="info-item">
        <div class="label">累计消费</div>
        <div class="value">0</div>
      </div>
      <div class="info-item">
        <div class="label">冻结积分</div>
        <div class="value">0</div>
      </div>
    </div>

    <!-- 积分明细 -->
    <div class="points-details">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="分值明细" name="detail">
          <empty-component text="暂无积分明细哦~"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyPoints',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'detail'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-points {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .points-info {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 30px;
    border-radius: 4px;
    margin-bottom: 20px;

    .info-item {
      text-align: center;

      .label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-question {
          margin-left: 4px;
          color: #999;
          cursor: pointer;
        }
      }

      .value {
        font-size: 24px;
        color: #333;
        font-weight: bold;
      }
    }
  }

  .points-details {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
